import React from 'react';
import { Check } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
const features = ['Recetas sin gluten', 'Organización semanal', 'Colaciones saludables', 'Horarios recomendados', 'Alimentación para cada edad', 'Hábitos saludables', 'Consejos prácticos', 'Bienestar digestivo', 'Vida saludable sin TACC'];
export function SystemOverview() {
  return <section className="py-20 bg-brand-950 text-white relative overflow-hidden" data-id="element-194">
      {/* Decorative background pattern */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'radial-gradient(#ffffff 1px, transparent 1px)',
      backgroundSize: '32px 32px'
    }} data-id="element-195"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-196">
        <FadeIn data-id="element-197">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-6" data-id="element-198">
            SISTEMA COMPLETO
            <span className="block text-brand-400 mt-2 text-2xl md:text-3xl" data-id="element-199">
              6 Módulos + 6 Bonos
            </span>
          </h2>
          <p className="text-xl text-brand-200 mb-12 max-w-2xl mx-auto" data-id="element-200">
            Todo organizado para ayudarte a mantener una alimentación saludable
            y segura.
          </p>
        </FadeIn>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4 max-w-4xl mx-auto" data-id="element-201">
          {features.map((feature, idx) => <FadeIn key={idx} delay={idx * 0.05} direction="up" data-id="element-202">
              <div className="flex items-center gap-2 px-4 py-2 md:px-6 md:py-3 rounded-full bg-brand-900 border border-brand-800 text-brand-100 font-medium text-sm md:text-base hover:bg-brand-800 transition-colors" data-id="element-203">
                <Check className="w-4 h-4 text-brand-400 flex-shrink-0" data-id="element-204" />
                <span data-id="element-205">{feature}</span>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}